<script lang="ts">
  import { createRadioGroup, melt } from "@melt-ui/svelte";
  import { scale } from "svelte/transition";
  import { cubicOut } from "svelte/easing";

  export interface RadioOption {
    value: string;
    label: string;
    disabled?: boolean;
  }

  interface Props {
    options: RadioOption[];
    value?: string;
    defaultValue?: string;
    name?: string;
    disabled?: boolean;
    orientation?: "horizontal" | "vertical";
    class?: string;
    onValueChange?: (args: { curr: string; next: string }) => void;
  }

  let {
    options,
    defaultValue,
    name,
    disabled = false,
    orientation = "vertical",
    class: className = "",
    onValueChange,
  }: Props = $props();

  const {
    elements: { root, item, hiddenInput },
    helpers: { isChecked },
    // svelte-ignore state_referenced_locally
  } = createRadioGroup({
    defaultValue,
    name,
    disabled,
    orientation,
    onValueChange: onValueChange
      ? (args) => {
          onValueChange(args);
          return args.next;
        }
      : undefined,
  });
</script>

<div
  {...$root} use:$root.action
  class="flex gap-2 {orientation === 'horizontal' ? 'flex-row' : 'flex-col'} {className}"
  role="radiogroup"
>
  {#each options as { value, label, disabled }}
    {@const __MELTUI_BUILDER_0__ = $item({ value, disabled })}
    <label
      class="flex cursor-pointer items-center gap-1.5 text-sm text-foreground-primary transition-colors"
      class:cursor-not-allowed={disabled}
      class:opacity-50={disabled}
    >
      <button
        type="button"
        {...__MELTUI_BUILDER_0__} use:__MELTUI_BUILDER_0__.action
        class="relative flex h-3.5 w-3.5 items-center justify-center rounded-full shadow-border-inset transition-all duration-200 ease-out"
        class:cursor-not-allowed={disabled}
        aria-label={label}
      >
        {#if $isChecked(value)}
          <div
            transition:scale={{ start: 0.1, duration: 200, easing: cubicOut, opacity: 1 }}
            class="h-2.5 w-2.5 rounded-full bg-pri-800"
          ></div>
        {/if}
      </button>
      <span class="select-none">{label}</span>
    </label>
  {/each}
  <input {...$hiddenInput} use:$hiddenInput.action />
</div>
